/**************************************************
 * Nombre:       Tarjeta_Producto
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid2, Typography} from "@mui/material";
import {formatoMoneda} from "../../Utilidades/formatoMoneda";
import {obtenerPorcentajeDescuento} from "../../Utilidades/obtenerPorcentajeDescuento";
import {useResponsive} from "../../Modulo_Responsive/Hooks/useResponsive";

const Tarjeta_Producto = ({item, click, index}) => {
    const {sCell} = useResponsive()

    return (
        <Grid2
            onClick={() => click(item, index)}
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{borderBottom: 1, borderColor: '#00000030', pr: 2, py: 1}}
        >

            <Grid2 container size={4}>
                <img src={item.img} width={'90%'} style={{borderRadius: 4}}/>
            </Grid2>

            <Grid2 container size={{xs: 8, sm: 8, md: 8}}>
                <Grid2
                    container
                    justifyContent={'flex-start'}
                    alignItems={'flex-end'}
                    size={{xs: 12, sm: 12, md: 12}}>


                    <Grid2 container size={{xs: 12, sm: 12, md: 12}} sx={{mb: 1}}>
                        <Typography
                            sx={{fontWeight: 600, lineHeight: 1.1, fontSize: 14}}>{`${item.nombre}`}</Typography>
                    </Grid2>

                    <Grid2 container size={{xs: 12, sm: 12, md: 6}} sx={{mt: -1}}>
                        <Typography sx={{fontWeight: 400, fontSize: 12, color: '#000000'}}>
                            {`V. und: ${formatoMoneda(item.valor)}`}
                        </Typography>
                    </Grid2>

                    <Grid2 container size={{xs: 12, sm: 12, md: 6}} sx={{mt: sCell ? 0 : -1}}>
                        <Typography
                            sx={{
                                fontWeight: 400,
                                fontSize: 12
                            }}>{`${item.presentacion} - ${item.marca}`}</Typography>
                    </Grid2>


                    <Grid2 container size={{xs: 12, sm: 12, md: 5}}>

                        <Grid2
                            container
                            justifyContent={'flex-start'}
                            alignItems={'flex-start'}
                            size={{xs: 12, sm: 12, md: 12}}>

                            {item.valorAntes &&

                                <Grid2 container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                                    <Typography sx={{
                                        fontWeight: 600,
                                        fontSize: 11,
                                        color: '#000000',

                                    }}>
                                        <span style={{textDecoration: 'line-through', marginRight: 4}}>
                                             {`${formatoMoneda(item.valorAntes)} `}
                                        </span>

                                        <span
                                        >{`(-${obtenerPorcentajeDescuento(item.valor, item.valorAntes)}%)`}</span>
                                    </Typography>
                                </Grid2>
                            }

                            <Grid2 container size={{xs: 12, sm: 12, md: 12}}
                                   sx={{justifyContent: 'flex-start', mt: item.valorAntes ? 0 : 2}}>
                                <Typography sx={{fontWeight: 600, fontSize: 12, color: '#00000090'}}>
                                    {`Cantidad: ${item.cantidad}`}
                                </Typography>
                            </Grid2>

                        </Grid2>

                    </Grid2>


                    <Grid2 container size={{xs: 12, sm: 12, md: 7}} justifyContent={'flex-end'}>
                        <Typography sx={{
                            fontWeight: 600,
                            fontSize: 14,
                        }}>{`Valor: ${formatoMoneda(item.cantidad * item.valor)}`}</Typography>
                    </Grid2>

                </Grid2>
            </Grid2>

        </Grid2>
    )

}
export default Tarjeta_Producto    